/* Presentation, explicit variant confirmation and accessible native navigation. */
(() => {
 const root=document.documentElement;
 root.dataset.v3Release='integral-20260911-v3';
 // Keep the review carousel controls functional without arrow text glyphs.
 const reviewBlock=document.querySelector('[id*="__revie_reviews_por_whatsapp_"]');
 if(reviewBlock){
  const cleanReviewControls=()=>{
   reviewBlock.querySelectorAll('.itemsC[data-go]').forEach(card=>{
    if(card.dataset.v4ReviewReady)return;
    card.dataset.v4ReviewReady='true';card.tabIndex=0;card.setAttribute('role','link');
    card.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();card.click();}});
    const stars=card.querySelector('.rv-stars');
    if(stars){const rating=parseFloat(stars.style.getPropertyValue('--rating'));if(Number.isFinite(rating)&&rating>=0&&rating<=5){stars.setAttribute('role','img');stars.setAttribute('aria-label',`${rating} de 5 estrellas`);}}
   });
   reviewBlock.querySelectorAll('.rv3-prev,.rv3-next').forEach(button=>{
   if(!/[❮❯]/.test(button.textContent))return;
   const previous=button.classList.contains('rv3-prev');
   const svg=document.createElementNS('http://www.w3.org/2000/svg','svg'),path=document.createElementNS('http://www.w3.org/2000/svg','path');
   svg.setAttribute('width','16');svg.setAttribute('height','16');svg.setAttribute('viewBox','0 0 16 16');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');
   path.setAttribute('d',previous?'m10 3-5 5 5 5':'m6 3 5 5-5 5');path.setAttribute('fill','none');path.setAttribute('stroke','currentColor');path.setAttribute('stroke-width','1.5');svg.append(path);
   button.setAttribute('aria-label',previous?'Reseñas anteriores':'Reseñas siguientes');button.replaceChildren(svg);
  });};
  cleanReviewControls();new MutationObserver(cleanReviewControls).observe(reviewBlock,{childList:true,subtree:true});
 }
 const header=document.querySelector('[data-v3-header]');
 if(header){
 const toggle=header.querySelector('.v3-menu-toggle'),nav=header.querySelector('.v3-nav'),closeButton=header.querySelector('.v4-drawer__close'),scrim=header.nextElementSibling?.classList.contains('v4-menu-scrim')?header.nextElementSibling:null;
 const breakpoint=matchMedia('(max-width:989px)');
 const setMobile=open=>{
  header.dataset.menuOpen=String(open);toggle?.setAttribute('aria-expanded',String(open));
  const label=toggle?.querySelector('.v3-sr');if(label)label.textContent=open?'Cerrar menú':'Abrir menú';
  if(breakpoint.matches){nav?.setAttribute('aria-hidden',String(!open));nav?.toggleAttribute('inert',!open);root.dataset.v3MenuLock=String(open);scrim?.setAttribute('aria-hidden',String(!open));}
  else{nav?.removeAttribute('aria-hidden');nav?.removeAttribute('inert');delete root.dataset.v3MenuLock;scrim?.setAttribute('aria-hidden','true');}
 };
 const close=()=>{header.querySelectorAll('details[open]').forEach(d=>d.open=false);setMobile(false);};
 toggle?.addEventListener('click',()=>{if(header.dataset.menuOpen==='true')close();else{if(nav)nav.scrollTop=0;setMobile(true);closeButton?.focus({preventScroll:true});}});
 closeButton?.addEventListener('click',()=>{close();toggle?.focus();});
 scrim?.addEventListener('click',()=>{close();toggle?.focus();});
 header.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)header.querySelectorAll('details[open]').forEach(other=>{if(other!==d)other.open=false;});}));
 document.addEventListener('keydown',e=>{
  if(e.key==='Tab'&&breakpoint.matches&&header.dataset.menuOpen==='true'){
   const focusable=[...nav.querySelectorAll('a,button,summary,input')].filter(el=>!el.disabled&&el.offsetParent!==null);
   if(focusable.length){const first=focusable[0],last=focusable.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}
  }
  if(e.key!=='Escape')return;
  const opened=header.querySelector('details[open]');
  if(opened){e.preventDefault();opened.open=false;opened.querySelector('summary')?.focus();return;}
  if(header.dataset.menuOpen==='true'){e.preventDefault();close();toggle?.focus();}
 });
 document.addEventListener('click',e=>{if(!header.contains(e.target))close();});
 breakpoint.addEventListener('change',()=>{const focused=header.contains(document.activeElement);close();if(focused){if(breakpoint.matches)toggle?.focus();else header.querySelector('.v3-nav summary,.v3-nav__direct')?.focus();}});
 setMobile(false);

 }
 document.querySelectorAll('.v3-film').forEach(film=>{
 const video=film.querySelector('video'),button=film.querySelector('.v3-film__toggle');
 if(!video||!button)return;
 button.hidden=false;video.controls=false;video.muted=true;video.defaultMuted=true;video.loop=true;video.playsInline=true;
 const autoAllowed=!matchMedia('(prefers-reduced-motion: reduce)').matches&&!navigator.connection?.saveData;
 video.autoplay=autoAllowed;
 let manuallyPaused=false,manuallyStarted=false;
 let inView=film.getBoundingClientRect().bottom>0&&film.getBoundingClientRect().top<innerHeight;
 const update=()=>{button.textContent=video.paused?'Reproducir video':'Pausar video';button.setAttribute('aria-label',button.textContent);};
 const syncPlayback=()=>{
  if(inView&&!document.hidden&&!manuallyPaused&&(autoAllowed||manuallyStarted))video.play().catch(update);
  else video.pause();
  update();
 };
 button.addEventListener('click',()=>{
  if(video.paused){manuallyPaused=false;manuallyStarted=true;video.play().catch(update);}
  else{manuallyPaused=true;video.pause();}
 });
 video.addEventListener('play',update);video.addEventListener('pause',update);
 video.addEventListener('loadeddata',syncPlayback);
 document.addEventListener('visibilitychange',syncPlayback);
 const observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;syncPlayback();},{threshold:.1});observer.observe(film);syncPlayback();
 });
 // Shopify remains responsible for all availability and cart mutations.
 // An explicit user choice is required before the native product form can submit.
 let confirmed=false;
 const variantScope=()=>document.querySelector('variant-picker,variant-selects');
 const identifySize=e=>e.matches('input[type="radio"],select')&&!!e.closest('variant-picker,variant-selects');
 const feedback=()=>{
 const picker=variantScope();if(!picker)return;
 root.dataset.v3SizePending=String(!confirmed);
 let note=picker.parentElement.querySelector('.v3-size-confirm');
 if(!note){note=document.createElement('p');note.className='v3-size-confirm';note.setAttribute('role','status');picker.after(note);}
 note.textContent=confirmed?'Talla seleccionada. Revisa tu elección antes de agregar.':'Selecciona tu talla para continuar.';
 note.dataset.error='false';
 };
 document.addEventListener('change',e=>{if(identifySize(e.target)){confirmed=true;setTimeout(feedback,350);}});
 document.addEventListener('click',e=>{const label=e.target.closest('label');if(label){const input=label.querySelector('input[type="radio"]')||document.getElementById(label.htmlFor);if(input&&identifySize(input)&&!input.disabled&&input.dataset.optionAvailable!=='false'){setTimeout(()=>{if(input.checked){confirmed=true;feedback();}},20);}}});
 window.addEventListener('submit',e=>{
 if(!(e.target instanceof HTMLFormElement)||!e.target.action.includes('/cart/add')||!variantScope()||confirmed)return;
 e.preventDefault();e.stopImmediatePropagation();feedback();
 const note=document.querySelector('.v3-size-confirm');if(note){note.textContent='Elige una talla antes de agregar al carrito.';note.dataset.error='true';note.scrollIntoView({block:'center',behavior:'smooth'});}
 variantScope()?.querySelector('input[type="radio"],select')?.focus({preventScroll:true});
 },true);
 window.addEventListener('click',e=>{
 const button=e.target.closest('button[type="submit"],button[data-testid="standalone-add-to-cart"]');
 if(!button||!button.form?.action.includes('/cart/add')||!variantScope()||confirmed)return;
 e.preventDefault();e.stopImmediatePropagation();feedback();
 const note=document.querySelector('.v3-size-confirm');
 if(note){note.textContent='Elige una talla antes de agregar al carrito.';note.dataset.error='true';note.scrollIntoView({block:'center'});}
 },true);
 feedback();
})();
